var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-table-cell" }, [
    _c(
      "div",
      { staticClass: "c-table-cell__wrapper cell-filial-settings" },
      [
        _vm.cellValue && _vm.localFilialSettings.length !== 0
          ? _c("c-popup", {
              staticClass: "cell-filial-settings__icon",
              attrs: {
                "cell-index": _vm.cellIndex,
                "post-code": _vm.postCode,
                title: _vm.column.fullName,
                scrollable: _vm.localFilialSettings.length > 6,
                "popup-position": "right",
                "popup-items": _vm.localFilialSettings,
              },
            })
          : _vm._e(),
        _c("div", { staticClass: "cell-filial-settings__value" }, [
          _vm._v(" " + _vm._s(_vm.cellValue) + " "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }